import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import Success from '../../Media/InboxV1/success.gif';
import Error from '../../Media/InboxV1/error.gif';
import Processing from '../../Media/InboxV1/loading.gif';

const STATUS_CONFIG = {
  success: { image: Success, text: 'Tour Scheduled' },
  error: { image: Error, text: '' },
  default: { image: Processing, text: 'Processing..' }
};

const TourBookingModal = ({
  status = '',
  errorText = 'Error: Selected time slot is not available.',
  handleBack
}) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.default;
  const displayText = status === 'error' ? errorText : config.text;
  const isError = status === 'error';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        my: 10,
        width: 600
      }}
    >
      <Box sx={{ height: 200, width: 200 }}>
        <Box
          component="img"
          src={config.image}
          alt={status}
          sx={{ height: '100%', width: '100%' }}
        />
      </Box>
      <Typography
        variant={isError ? 'body2' : 'h4'}
        color={isError ? 'error' : 'text.primary'}
      >
        {isError ? 'Error: ' : ''}
        {displayText}
      </Typography>
      {isError && (
        <Link
          component="button"
          variant="body2"
          underline="always"
          onClick={handleBack}
        >
          {errorText === 'TIME_NOT_AVAILABLE'
            ? 'Select different time slot'
            : 'Try again'}
        </Link>
      )}
    </Box>
  );
};

export default TourBookingModal;
